export class HaveNotRedirectParamError extends Error {
  constructor() {
    super("url don't have redirect param");
  }
}